import { forEach } from 'lodash'
import { useEffect } from 'react'
import { useForm } from 'react-final-form'

import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'

export function useServiceDeactivation(): void {
  const name = useFieldValue<string>('name')
  const isEnabled = useFieldValue<boolean>('isEnabled')
  const disallows = useFieldValue<string[]>('disallows') || []

  const form = useForm()
  const shipmentServices = useFieldValue<any[]>('shipmentServices', {
    ignorePrefix: true,
  })

  useEffect(() => {
    if (!isEnabled) return
    forEach(shipmentServices, (service, index) => {
      if (disallows.includes(service.name)) {
        form.change(`shipmentServices[${index}].isEnabled`, false)
      }
    })
  }, [name, disallows, shipmentServices, isEnabled])
}
